import React from 'react'
import { getImageURL } from '../../lib/utils/getImageURL'
import classNames from 'classnames'

const CampaignExampleCard = ({
  url,
  title,
  uppercase,
  textSize,
  body,
}: {
  url: string
  title: string
  uppercase?: boolean
  textSize?: 'text-xs' | 'text-sm' | 'text-lg' | 'text-xl' | 'text-2xl'
  body: string
}): JSX.Element => {
  return (
    <div className={'flex flex-col justify-start'}>
      <img src={getImageURL(url)} className={'object-contain'} />
      <span
        className={classNames(`${textSize ?? ''} font-bold font-Spartan mt-5`, {
          // eslint-disable-next-line prettier/prettier
          'uppercase': uppercase,
        })}>
        {title}
      </span>
      <span className={`${textSize ?? ''} font-medium mt-2`}>{body}</span>
    </div>
  )
}

export default CampaignExampleCard
